import Vue from "vue"
/* import componentsApi from "../../api/components" */
import utilsApi from "@/api/utils"
import { createFetchPageAction } from "@/store/helpers/createFetchPageAction"
const initialObject = {
  _id: undefined,
  site: undefined,
  name: undefined,
  body: {},
  status: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  component: undefined
}
const objectFieldsToSend = ["_id", "name", "body", "status"]
const objectToSend = (object) => {
  return Object.keys(object)
    .filter((key) => objectFieldsToSend.includes(key))
    .reduce((obj, key) => {
      obj[key] = object[key]
      return obj
    }, {})
}

// general state for the site

const initialState = {
  components: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  components: (state) => state.components,
  componentsIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  componentsError: (state) => state.error,
  components_Object: (state) => state.object,
  components_isNew: (state) => state.isNew,
  components_selected: (state) => state.selected
}
const actions = {
  async DELETE_components({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("components", object)
    if (apiResponse != null) {
      //commit("COMPONENTS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_components", state.page)

      return true
    } else {
      commit("COMPONENTS_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_components({ state, commit, dispatch }) {
    let deletions = await state.selected.map(async (object) => {
      return await dispatch("DELETE_components", object)
    })
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_components", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_componentsState({ commit }, payload) {
    commit("SET_components", payload)
    return true
  },
  async UPDATE_components({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.updateObject(
      "components",
      objectToSend(object)
    )
    if (apiResponse != null) {
      commit("COMPONENTS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_components", state.page)

      return true
    } else {
      commit("COMPONENTS_ERROR")
      return false
    }
  },
  async CREATE_components({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("components", object)
    if (apiResponse != null) {
      commit("SET_components", {
        param: "object",
        value: apiResponse.component
      })
      dispatch("FETCH_PAGE_components", state.page)

      return true
    } else {
      commit("COMPONENTS_ERROR")
      return false
    }
  },
  async FETCH_components({ commit }) {
    let apiResponse = await utilsApi.getObjects("components")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("COMPONENTS_SETTING", apiResponse)
      return true
    } else {
      commit("COMPONENTS_ERROR")
      return false
    }
  },

  FETCH_PAGE_components: createFetchPageAction(
    "components",
    "COMPONENTS_SETTING",
    "COMPONENTS_ERROR",
    "components"
  ),

  UPDATE_OBJECT_components({ commit }, payload) {
    commit("SET_OBJECT_COMPONENT", payload)
    return true
  },
  CLEAN_OBJECT_components({ commit }) {
    commit("SET_OBJECT_COMPONENT_INITIAL")
    return true
  },
  async CLEAN_STORE_components({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_components", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_components({ commit }, payload) {
    commit("SET_SELECTED_COMPONENTS", payload)
    return true
  }
}
const mutations = {
  COMPONENTS_SETTING: (state, { components, count = undefined, page }) => {
    state.count = count ?? state.components.length
    state.page = page ?? state.page
    state.components = components
    state.fetched = true
    state.error = false
  },
  COMPONENTS_ERROR: (state) => {
    state.components = null
    state.fetched = true
    state.error = false
  },
  SET_OBJECT_COMPONENT: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_COMPONENT_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_COMPONENTS: (state, selectedPages) => {
    state.selected = selectedPages
  },
  SET_components: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
